import DialogQuestion from './dialog_question'
import Service from './service'
export var DialogMessageType;
(function (DialogMessageType) {
  DialogMessageType["DIALOG_ACTION"] = "DIALOG_ACTION"
  DialogMessageType["DIALOG_USER_REPLIC"] = "DIALOG_USER_REPLIC"
  DialogMessageType["DIALOG_REPLIC_START"] = "DIALOG_REPLIC_START"
  DialogMessageType["DIALOG_REPLIC_FINISH"] = "DIALOG_REPLIC_FINISH"
  DialogMessageType["DIALOG_LOAD_REPLIC"] = "DIALOG_LOAD_REPLIC"
  DialogMessageType["DIALOG_LOAD_ANSWER"] = "DIALOG_LOAD_ANSWER"
  DialogMessageType["DIALOG_LOAD_GREETING"] = "DIALOG_LOAD_GREETING"
  DialogMessageType["DIALOG_LOAD_EXTRA_REPLIC"] = "DIALOG_LOAD_EXTRA_REPLIC"
  DialogMessageType["DIALOG_QUESTION_NEW"] = "DIALOG_QUESTION_NEW"
  DialogMessageType["DIALOG_QUESTION_CANCEL"] = "DIALOG_QUESTION_CANCEL"
})(DialogMessageType || (DialogMessageType = {}))
export var ApiDialogMessageType;
(function (ApiDialogMessageType) {
  ApiDialogMessageType["QUESTION_CANCEL"] = "dialog.question.cancel"
  ApiDialogMessageType["QUESTION_NEW"] = "dialog.question.new"
  ApiDialogMessageType["QUESTION_ANSWER"] = "dialog.question.answer"
  ApiDialogMessageType["SAY"] = "dialog.say"
  ApiDialogMessageType["REPLIC_GET"] = "dialog.replica.get"
  ApiDialogMessageType["REPLIC_LOAD"] = "dialog.replica.load"
  ApiDialogMessageType["REPLIC_EXTRA_LOAD"] = "dialog.replica.extra.load"
  ApiDialogMessageType["ANSWER_LOAD"] = "dialog.answer.load"
  ApiDialogMessageType["GREETING_LOAD"] = "dialog.greeting.load"
  ApiDialogMessageType["USER_SAID"] = "dialog.user.said"
  ApiDialogMessageType["ROBOT_REPLIC_START"] = "dialog.robot.replic.start"
  ApiDialogMessageType["ROBOT_REPLIC_FINISH"] = "dialog.robot.replic.finish"
  ApiDialogMessageType["ROBOT_REPLIC_ABORT"] = "dialog.robot.replic.abort"
  ApiDialogMessageType["USER_ACTION"] = "dialog.action"
  ApiDialogMessageType["SYSTEM_PLAY_STATUS"] = "system.play.status"
  ApiDialogMessageType["SYSTEM_PLAY_EXTERNAL"] = "system.play.external"
})(ApiDialogMessageType || (ApiDialogMessageType = {}))
/** см. https://pb2.icmm.ru/replicatype/index */
var ReplicTypes;
(function (ReplicTypes) {
  /** Не классифицируетя или фраза из приложения робота */
  ReplicTypes[ReplicTypes["NONE"] = 0] = "NONE"
  /** Фразы приветствия известного */
  ReplicTypes[ReplicTypes["GREETING"] = 1] = "GREETING"
  /** Фразы приветствия неизвестного */
  ReplicTypes[ReplicTypes["GREETING_UNKNOWN"] = 2] = "GREETING_UNKNOWN"
  /** Промо-материалы */
  ReplicTypes[ReplicTypes["PROMO"] = 3] = "PROMO"
  /** Нераспознанные фразы */
  ReplicTypes[ReplicTypes["UNRECOGNIZED"] = 4] = "UNRECOGNIZED"
  /** Вопросы анкеты */
  ReplicTypes[ReplicTypes["INTERVIEW"] = 5] = "INTERVIEW"
  /** Дополнительная фраза */
  ReplicTypes[ReplicTypes["ADDITIONAL"] = 6] = "ADDITIONAL"
  /** Общая база (высокий приоритет) */
  ReplicTypes[ReplicTypes["COMMON_BASE"] = 13] = "COMMON_BASE"
  /** Фраза с джойстика */
  ReplicTypes[ReplicTypes["JOYSTICK"] = 16] = "JOYSTICK"
  /** deprecated */
  ReplicTypes[ReplicTypes["INTRODUCTORY"] = 17] = "INTRODUCTORY"
  /** Навигационная реплика */
  ReplicTypes[ReplicTypes["NAVIGATION"] = 18] = "NAVIGATION"
  /** Смена темы */
  ReplicTypes[ReplicTypes["APPROACH"] = 19] = "APPROACH"
  /** Приветствие после знакомства */
  ReplicTypes[ReplicTypes["GREETING_AFTER_ACQ"] = 20] = "GREETING_AFTER_ACQ"
  /** Фразы в ответ на перебивание */
  ReplicTypes[ReplicTypes["INTERRUPTING"] = 27] = "INTERRUPTING"
})(ReplicTypes || (ReplicTypes = {}))
/**
 * Сервис диалоговой системы
 * @version 0.0.1
 * @since 1.8.0
 */
export default class DialogService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    this.isMuted = false
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiDialogMessageType.QUESTION_NEW:
          const question = new DialogQuestion(message, messageChannel)
          this.broadcast(DialogMessageType.DIALOG_QUESTION_NEW, question)
          break
        case ApiDialogMessageType.QUESTION_CANCEL:
          this.broadcast(DialogMessageType.DIALOG_QUESTION_CANCEL, message.meta)
          break
        case ApiDialogMessageType.USER_ACTION:
          this.broadcast(DialogMessageType.DIALOG_ACTION, message.meta)
          break
        case ApiDialogMessageType.USER_SAID:
          this.broadcast(DialogMessageType.DIALOG_USER_REPLIC, message.text, message.is_finish)
          break
        case ApiDialogMessageType.ROBOT_REPLIC_START:
          this.broadcast(DialogMessageType.DIALOG_REPLIC_START, message.text)
          break
        case ApiDialogMessageType.ROBOT_REPLIC_FINISH:
          this.broadcast(DialogMessageType.DIALOG_REPLIC_FINISH, message.text)
          break
        case ApiDialogMessageType.ANSWER_LOAD:
          if (this.isMuted) {
            message.answer.replica.anchor = null
            message.answer.replica.animation = null
            message.answer.replica.text = '"'
            message.answer.replica.url = null
            message.answer.replica.actions = null
          }
          this.broadcast(DialogMessageType.DIALOG_LOAD_ANSWER, message.answer)
          break
        case ApiDialogMessageType.GREETING_LOAD:
          this.broadcast(DialogMessageType.DIALOG_LOAD_GREETING, message.greeting)
          break
        case ApiDialogMessageType.REPLIC_LOAD:
          this.resolve(this.waiters.replic, message.replica)
          this.broadcast(DialogMessageType.DIALOG_LOAD_REPLIC, message.replica)
          break
        case ApiDialogMessageType.REPLIC_EXTRA_LOAD:
          this.broadcast(DialogMessageType.DIALOG_LOAD_EXTRA_REPLIC, message.replica)
          break
      }
    }
    this.waiters = {
      replic: [],
    }
    const messageTypesForSubscribe = [
      ApiDialogMessageType.QUESTION_NEW,
      ApiDialogMessageType.QUESTION_CANCEL,
      ApiDialogMessageType.USER_ACTION,
      ApiDialogMessageType.USER_SAID,
      ApiDialogMessageType.ROBOT_REPLIC_START,
      ApiDialogMessageType.ROBOT_REPLIC_FINISH,
      ApiDialogMessageType.REPLIC_LOAD,
      ApiDialogMessageType.REPLIC_EXTRA_LOAD,
      ApiDialogMessageType.ANSWER_LOAD,
      ApiDialogMessageType.GREETING_LOAD,
      ApiDialogMessageType.SYSTEM_PLAY_STATUS,
    ]
    messageTypesForSubscribe.forEach(messageType => {
      this.messageChannel.subscribe(messageType, messageHandler)
    })
  }
  get isMute() {
    return this.isMuted
  }
  /**
     * Получить реплику по типу
     *
     * @since 1.8.0
     * @param {ReplicTypes} type - тип реплики
     * @param {(DialogCategory | null)} [category=null] - категория реплики
     * @param {(FaceStructure | null)} [face=null] - лицо для которого предназначена реплика
     * @return {*}  {Promise<DialogReplica>}
     * @memberof DialogService
     *
     * @example <caption>Получить реплику по типу</caption>
     * robot.dialogService.getReplic(type, category, face).then((replic) => {
     * })
     */
  getReplic(type, category = null, face = null) {
    // ToDo REPLIC_TYPES[replica_type] || replica_type,
    return this.execute({
      type: ApiDialogMessageType.REPLIC_GET,
      replica_type: type,
      category,
      face,
    }, this.waiters.replic)
  }
  /**
     * Получить реплику шага
     *
     * @since 1.8.0
     * @param {string} step - название шага
     * @param {(DialogCategory | null)} [category=null] - категория реплики
     * @param {(FaceStructure | null)} [face=null] - лицо для которого предназначена реплика
     * @return {*}  {Promise<DialogReplica>}
     * @memberof DialogService
     *
     * @example <caption>Получить реплику шага</caption>
     * robot.dialogService.getReplicByName().then((replic) => {
     * })
     */
  getReplicByName(step, category = null, face = null) {
    return this.execute({
      type: ApiDialogMessageType.REPLIC_GET,
      step,
      category,
      face,
    }, this.waiters.replic)
  }
  /**
     * Произнести ответ
     *
     * @since 1.8.0
     * @param {DialogAnswer} answer - ответ
     * @param {boolean} [terminate=false] - прерывать ли текущую реплику
     * @memberof DialogService
     *
     * @example <caption>Произнести ответ</caption>
     * robot.dialogService.sayAnswerByData(answer, terminate)
     */
  sayAnswerByData(answer, terminate = false) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SAY,
      answer,
      terminate,
    })
  }
  /**
     * Произнести реплику по данным
     *
     * @since 1.0.0
     * @param {DialogReplica} replica - реплика
     * @param {boolean} [terminate=false] - прервать текущую реплику
     * @memberof DialogService
     *
     * @example <caption>Произнести реплику по данным</caption>
     * robot.dialogService.sayReplicByData(replica, terminate)
     */
  sayReplicByData(replica, terminate = false) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SAY,
      replica,
      terminate,
    })
  }
  /**
     * Произнести реплику по названию шага
     *
     * Опционально:
     * - Заменить макрос;
     * - Передать лицо, чтобы лингва могла найти подходящую реплику.
     *
     * `Где макрос - это строка в лингвобазе, которая отвечает за динамически подставляемые значений,
     * например в макрос user - будет автоматически подставлено имя текущего пользователя.`
     *
     * В результате, строка: "Привет, {user}, как дела?"
     *
     * Будет преобразована в: "Привет, Максим, как дела?"
     *
     * (если робот знает имя текущего пользователя и распознал его как Максим)
     *
     * @param {string} step - название шага
     * @param {boolean} [terminate=false] - прервать текущую реплику
     * @param {(DialogMarcoses | { macroses?: DialogMarcoses, face?: FaceStructure })} [options={}] - объект, содержащий макросы, которые необходимо заменить, либо объект, который может содержать макросы и/или лицо
     * @return {*}  {void}
     * @memberof DialogService
     *
     * @example <caption>Произнести реплику по названию шага и заменить макрос user на 'тестовый пользователь'</caption>
     * robot.dialogService.sayReplicByName(step, terminate, { user: 'тестовый пользователь' })
     *
     * @example <caption>Произнести реплику по названию шага и передать лицо</caption>
     * robot.dialogService.sayReplicByName(step, terminate, { face: { id: 123, is_tracking: true, track_id: 12346, etc... } })
     */
  sayReplicByName(step, terminate = false, options = {}) {
    const hasMacroses = Object.prototype.hasOwnProperty.call(options, 'macroses')
    const hasFace = Object.prototype.hasOwnProperty.call(options, 'face')
    const baseRequest = {
      type: ApiDialogMessageType.SAY,
      step,
      terminate
    }
    if (!hasMacroses && !hasFace) {
      return this.messageChannel.send(Object.assign(Object.assign({}, baseRequest), { macroses: options }))
    }
    let requestOptions = {}
    if (hasMacroses) {
      requestOptions = {
        macroses: options.macroses
      }
    }
    if (hasFace) {
      requestOptions = Object.assign(Object.assign({}, requestOptions), { face: options.face })
    }
    return this.messageChannel.send(Object.assign(Object.assign({}, baseRequest), requestOptions))
  }
  /**
     * Отправить текст в спикер и произнести его
     *
     * @since 1.0.0
     * @param {string} text - текст для произношения
     * @param {boolean} [terminate=false] - прервать текущую реплику
     * @memberof DialogService
     *
     * @example <caption>Произнести текст</caption>
     * robot.dialogService.sayText('Привет робот', true)
     */
  sayText(text, terminate = false) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SAY,
      terminate,
      text,
    })
  }
  /**
     * Установить макросы
     *
     * @param {Object} macroses - Макросы
     * @memberof DialogService
     *
     * @example <caption>Установить макросы</caption>
     * robot.dialogService.setMacroses(macroses)
     */
  setMacroses(macroses) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SAY,
      macroses,
    })
  }
  /**
     * Установить лингвокейс в диалоговой системе
     *
     * @since 1.9.0
     * @param {string} name - название лингвокейса
     * @param {boolean} [terminate=true] - прервать текущую реплику
     * @param {boolean} [isExtend=false] - является ли лингвокейс расширенным
     * @memberof DialogService
     *
     * @example <caption>Установить лингвокейс в диалоговой системе</caption>
     * robot.dialogService.setCase(name, terminate, isExtend)
     */
  setCase(name, terminate = true, isExtend = false) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SAY,
      terminate,
      replica: {
        id: {
          uuid: this.uuid(),
        },
        actions: isExtend
          ? `lingvoCase:${ name }:extend`
          : `lingvoCase:${ name }`,
        text: '"',
        type: 21,
      },
    })
  }
  /**
     * Прервать произношение реплики
     *
     * @since 1.0.0
     * @memberof DialogService
     *
     * @example <caption>Прервать произношение реплики</caption>
     * robot.dialogService.abortRobotReplic()
     */
  abortRobotReplic() {
    this.messageChannel.send({
      type: ApiDialogMessageType.ROBOT_REPLIC_ABORT,
    })
  }
  /**
     * Установить состояние "тихого режима" при ответах на вопросы
     *
     * @since 1.0.0
     *
     * @param {boolean} status - состояние "тихого режима"
     * true - робот переходит в тихий режим и не отвечает на вопросы
     * (текст ответа заменяется на пустой)
     * false - робот выходит из тихого режима и отвечает на вопросы
     *
     * @memberof DialogService
     *
     * @example <caption>Установить состояние "тихого режима" при ответах на вопросы</caption>
     * robot.dialogService.mute(status)
     */
  mute(status) {
    this.isMuted = Boolean(status)
  }
  /**
     * Включить состояние "тихого режима" при ответах на вопросы
     * робот переходит в тихий режим и не отвечает на вопросы
     * (текст ответа заменяется на пустой)
     *
     * @since 1.0.0
     * @memberof DialogService
     *
     * @example <caption>Включить состояние "тихого режима" при ответах на вопросы</caption>
     * robot.dialogService.muteOn()
     */
  muteOn() {
    this.mute(true)
  }
  /**
     * Отключить состояние "тихого режима" при ответах на вопросы
     * робот выходит из тихого режима и отвечает на вопросы
     *
     * @since 1.0.0
     * @memberof DialogService
     *
     * @example <caption>Отключить состояние "тихого режима" при ответах на вопросы</caption>
     * robot.dialogService.muteOff()
     */
  muteOff() {
    this.mute(false)
  }
  /**
     * Диалоговая система отправила информацию о question
     * question - это вопрос с вариантами ответа
     *
     * @since 1.0.0
     * @param {(text: string, answers: Array<string>) => void} newQuestionCallback - функция обработки для случаев, когда
     * диалоговая система сообщает о необходимости показать question c вопросом text и
     * вариантами ответа answers
     * @param {() => void} cancelQuestionCallback - функция обработки для случаев, когда
     * диалоговая система сообщает о необходимости скрыть question
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система отправила question</caption>
     * robot.dialogService.onQuestion((text, answers) => {
     *   ...
     * },
     * () => {
     *   ...
     * })
     */
  onQuestion(newQuestionCallback, cancelQuestionCallback) {
    const subscribers = [
      this.subscribe(DialogMessageType.DIALOG_QUESTION_NEW, newQuestionCallback),
      this.subscribe(DialogMessageType.DIALOG_QUESTION_CANCEL, cancelQuestionCallback)
    ]
    /**
         * mock UnsubscribeFunction
         * Т.к. у нас передается 2 колбэка и как нам понять какой из них правильно дернуть, чтобы отписаться от всего?
         * По-хорошему необходимо на каждый колбэк реализовать отдельный метод
         */
    return function unsubscribeFunction() {
      subscribers.forEach(unsubscribe => unsubscribe())
      return true
    }
  }
  /**
     * Диалоговая система отправила действие (экшн)
     * действие может быть разбито на несколько элементов массива
     *
     * @since 1.0.0
     * @param {(actions: Array<string>) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система отправила действие</caption>
     * robot.dialogService.onAction((actions) => {
     *   ...
     * })
     */
  onAction(callback) {
    return this.subscribe(DialogMessageType.DIALOG_ACTION, callback)
  }
  /**
     * Пользователь произнес реплику
     *
     * @since 1.0.0
     * @param {(text: string, isFinish: boolean) => void} callback
     * text - распознанная речь пользователя
     * isFinish - законченность речи
     *   true - система распознавания считает, что это законченная речь
     *   false - текст может измениться при дальнейшем распознавании
     *
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Пользователь произнес реплику</caption>
     * robot.dialogService.onUserReplic((text, isFinish) => {
     *   ...
     * })
     */
  onUserReplic(callback) {
    return this.subscribe(DialogMessageType.DIALOG_USER_REPLIC, callback)
  }
  /**
     * Робот начал произносить реплику
     *
     * @since 1.0.0
     * @param {(text: string) => void} callback - текст, который робот начал произносить
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Робот начал произносить реплику</caption>
     * robot.dialogService.onRobotReplicStart((text) => {
     *   ...
     * })
     */
  onRobotReplicStart(callback) {
    return this.subscribe(DialogMessageType.DIALOG_REPLIC_START, callback)
  }
  /**
     * Робот завершил произносить реплику
     *
     * @since 1.0.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Робот завершил произносить реплику</caption>
     * robot.dialogService.onRobotReplicFinish(() => {
     *   ...
     * })
     */
  onRobotReplicFinish(callback) {
    return this.subscribe(DialogMessageType.DIALOG_REPLIC_FINISH, callback)
  }
  /**
     * Диалоговая система нашла ответ на реплику пользователя
     * Которую необходимо дальше передать по цепочке sayAnswerByData
     *
     * @since 1.8.0
     * @param {(answer: DialogAnswer) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система нашла ответ на реплику пользователя</caption>
     * robot.dialogService.onLoadAnswer((answer) => {
     *   robot.dialogService.sayAnswerByData(answer, true)
     * })
     */
  onLoadAnswer(callback) {
    return this.subscribe(DialogMessageType.DIALOG_LOAD_ANSWER, callback)
  }
  /**
     * Диалоговая система хочет произнести приветствие
     *
     * @since 1.8.0
     * @param {(replic: DialogReplica) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система хочет произнести приветствие</caption>
     * robot.dialogService.onLoadGreeting((replic) => {
     *   ...
     * })
     */
  onLoadGreeting(callback) {
    return this.subscribe(DialogMessageType.DIALOG_LOAD_GREETING, callback)
  }
  /**
     * Диалоговая система прислала реплику в ответ на запрос
     *
     * @since 1.8.0
     * @param {(replic: DialogReplica) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система прислала реплику в ответ на запрос</caption>
     * robot.dialogService.onLoadReplic((replic) => {
     *   ...
     * })
     */
  onLoadReplic(callback) {
    return this.subscribe(DialogMessageType.DIALOG_LOAD_REPLIC, callback)
  }
  /**
     * Диалоговая система сообщила добавочную реплику
     *
     * @since 1.8.0
     * @param {(replic: DialogReplica) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof DialogService
     *
     * @example <caption>Диалоговая система сообщила добавочную реплику</caption>
     * robot.dialogService.onLoadExtraReplic((replic) => {
     *   ...
     * })
     */
  onLoadExtraReplic(callback) {
    return this.subscribe(DialogMessageType.DIALOG_LOAD_EXTRA_REPLIC, callback)
  }
  /**
     * Отправить ответ на вопрос в диалоговую систему
     * Имитация распознанной речи
     *
     * @since 1.0.0
     * @param {string} text - текст ответа
     * @memberof DialogService
     *
     * @example <caption>Отправить ответ на вопрос в диалоговую систему</caption>
     * robot.dialogService.setAnswer(text)
     */
  setAnswer(text) {
    this.messageChannel.send({
      type: ApiDialogMessageType.QUESTION_ANSWER,
      text,
    })
  }
  /**
     * Проиграть внешний mp3 файл
     *
     * @since 1.8.0
     * @param {string} url - url файла
     * может начинаться с:
     * http:// для файлов из интернета
     * file:// для локальных файлов робота
     *
     * @param {number} volume - громкость динамика
     * @memberof DialogService
     *
     * @example <caption>проиграть внешний mp3 файл</caption>
     * robot.dialogService.externalPlay('http://...', 20)
     */
  externalPlay(url, volume) {
    this.messageChannel.send({
      type: ApiDialogMessageType.SYSTEM_PLAY_EXTERNAL,
      url,
      volume,
    })
  }
  /**
     * Остановить проигрывание файла
     *
     * @since 1.8.0
     * @memberof DialogService
     *
     * @example <caption>остановить проигрывание файла</caption>
     * robot.dialogService.externalPlayStop()
     */
  externalPlayStop() {
    this.messageChannel.send({
      type: ApiDialogMessageType.SYSTEM_PLAY_EXTERNAL,
      stop: '',
    })
  }
}
